export function filterArrayByMatchCount(arr: any[]) {
  return (arr && arr.filter((item) => item.doc_count > 0)) || [];
}
